import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { SuperPlatformAI } from './pages/SuperPlatformAI';
import { QuasarPlatform } from './pages/QuasarPlatform';
import { UDSAPlatform } from './pages/UDSAPlatform';
export function AppRouter() {
  return <BrowserRouter data-id="element-148">
      <Routes data-id="element-149">
        <Route path="/" element={<App data-id="element-151" />} data-id="element-150" />
        <Route path="/super-platform-ai" element={<SuperPlatformAI data-id="element-153" />} data-id="element-152" />
        <Route path="/quasar" element={<QuasarPlatform data-id="element-155" />} data-id="element-154" />
        <Route path="/udsa" element={<UDSAPlatform data-id="element-157" />} data-id="element-156" />
      </Routes>
    </BrowserRouter>;
}